export default __webpack_public_path__ + "static/media/16.3e88b77c.webp";